import { createAsyncThunk } from "@reduxjs/toolkit";
import { IQueryParams, getSearchQuery } from "../../../common";
import { axios_api } from "../../../api/axios-api";
import { IPosBankInfo } from "./bank-info.types";
import { closeLoaderWithMessage, openLoaderWithMessage } from "../../common";

const GET_ACCOUNTING_BANK_INFO_ENDPOINT= "/accounting/get-accounting-bank-info"
const UPSERT_ACCOUNTING_BANK_INFO_ENDPOINT = "/accounting/upsert-accounting-bank-info"

export const fetchPosBankInfoListWithArgsAsync = createAsyncThunk<{ recordCount: number, data: IPosBankInfo[] }, IQueryParams>(
    'pos-bank-info/fetchPosBankInfoListWithArgsAsync', async (queryParams: IQueryParams, thunkAPI) => {
        thunkAPI.dispatch(openLoaderWithMessage("Fetching Details...!"))
        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${GET_ACCOUNTING_BANK_INFO_ENDPOINT}${searchQuery}`)
        const data = response.data.data;
        const count = response.data.totalRecords
        thunkAPI.dispatch(closeLoaderWithMessage())
        return { recordCount: count, data: data }
    },
)


export const upsertSinglePosBankInfoAsync = createAsyncThunk<IPosBankInfo, IPosBankInfo>(
    'pos-bank-info/upsertSinglePosBankInfoAsync', async (payload: IPosBankInfo, thunkAPI) => {
        thunkAPI.dispatch(openLoaderWithMessage("Saving Changes...!"))
        
        const response = await axios_api.post(UPSERT_ACCOUNTING_BANK_INFO_ENDPOINT, payload)
        thunkAPI.dispatch(fetchPosBankInfoListWithArgsAsync({
            page: 1,
            rowsPerPage: 10
        }))
        thunkAPI.dispatch(closeLoaderWithMessage())
        return response.data
    },
)